import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
  initialOpen?: boolean;
}

export function FAQItem({
  question,
  answer,
  initialOpen = false,
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  return (
    <div
      className={`mb-3 overflow-hidden rounded-xl border bg-white transition-all duration-300 ${
        isOpen
          ? 'border-primary shadow-md'
          : 'border-gray-200 shadow-sm hover:border-primary/40 hover:shadow'
      }`}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
        className={`flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold transition-colors duration-200 md:text-lg ${
          isOpen ? 'text-primary' : 'text-gray-800 hover:text-primary'
        }`}
      >
        <span>{question}</span>
        <span
          className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
            isOpen
              ? 'rotate-45 border-primary bg-primary text-white'
              : 'border-gray-300 bg-gray-50 text-gray-500'
          }`}
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </span>
      </button>

      {/* grid-rows trick animates height smoothly from 0fr -> 1fr */}
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <p className="px-5 pb-5 text-sm leading-relaxed text-gray-600">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}
